/* eslint-disable import/prefer-default-export */
export const uiConstants = {
  COMMENT_SIDEBAR: 'UI_COMMENT_SIDEBAR',
};
